import { GET_PIPELINE_BY_ID } from "constants/pipelines";

export default (state = null, action) => {
  switch (action.type) {
    case `${GET_PIPELINE_BY_ID}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
